export const support = {
  seo: {
    title: 'Kontakt & Support | Bistroo',
    description: 'Kontaktiere das Bistroo-Supportteam per Telefon, WhatsApp oder E-Mail. Wir helfen dir schnell weiter.',
  },
  hero: {
    heading: {
      1: 'Unser',
      2: 'Kundenservice',
      3: 'steht dir gerne zur Verfügung',
    },
    description: {
      1: 'Willkommen bei unserem Kundenservice',
      2: 'Um dir bestmöglich helfen zu können, bitten wir dich, unten eine Auswahl aus den verfügbaren Optionen zu treffen. So stellen wir sicher, dass du direkt zu den richtigen Informationen oder Kontaktmöglichkeiten gelangst.',
    },
  },
  cards: {
    helpcenter: {
      description: 'Alle Informationen, die du benötigst',
      title: 'Hilfezentrum & FAQ',
      text: 'Besuche unser Hilfezentrum für Ratschläge und Antworten auf all deine Fragen. Oder lies unsere FAQ-Seite mit den am häufigsten gestellten Fragen.',
      actions: {
        helpcenter: 'Hilfezentrum besuchen',
        faq: 'Häufig gestellte Fragen',
      },
    },
    demo: {
      description: 'Support-Team',
      title: 'Eine Demo',
      text: 'Eine Demo mit unserem Team?',
      action: {
        title: 'Eine Demo anfragen',
        button: 'Anfragen',
      },
    },
    address: {
      description: 'Bistroo',
      title: 'Unsere Adresse',
      text: 'Du kannst uns unter der folgenden Adresse finden',
      address: {
        mail: 'Postadresse:',
        visit: 'Besuchsadresse (nach Vereinbarung)',
      },
    },
    contact: {
      description: 'Uns erreichen',
      title: 'Kontakt',
      text: 'Möchtest du direkt mit uns Kontakt aufnehmen? Das ist möglich!',
    },
    partners: {
      description: 'Partner werden',
      title: 'Partner',
      text: 'Lasse dein Geschäft wachsen und werde Partner von Bistroo!',
      action: {
        title: 'Partner werden',
        button: 'Weiterlesen',
      },
    },
  },
}
